import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";

const ErrorUploadModal = props => {
  const dispatch = useDispatch();
  const { isOpen, toggle, error } = props;

  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const { reportLog: reportLog } = summaryInvoiceData;

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  return (
    <Modal
      size="sm"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      style={{ minWidth: "40%" }}
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          <Label>Lý do</Label>
        </ModalHeader>
        {reportLog.loading ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="0"
              countButton="2"
              formClass="row-cols-1 row-cols-md-1"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <Row
                className="font-size-14 mt-1"
                style={{ maxHeight: "80vh", overflow: "auto" }}
              >
                <Col>
                  <div
                    dangerouslySetInnerHTML={{ __html: reportLog?.data }}
                  ></div>
                </Col>
              </Row>
            </ModalBody>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

ErrorUploadModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  error: PropTypes.any,
};

export default ErrorUploadModal;
